import { CompanyStatusEnum } from 'constants/company'
import { connect } from 'react-redux'
import { getWaiter } from 'redux-waiter'
import { selectors as companySelectors } from 'store/modules/companies'
import { GET_ALL_COMPANIES } from 'store/modules/companies/constants'
import {
  actions as userSessionActions,
  selectors as userSessionSelectors,
} from 'store/modules/user-session'
import { Company } from 'types/company'
import { HeaderCompanySelector } from './HeaderCompanySelector'

const mapStateToProps = (state) => {
  const companyList: Company[] = Object.values(
    companySelectors.companyCollectionSelector(state)
  )
  const filteredCompany = (companyList ?? []).filter(
    (company) => company.status === CompanyStatusEnum.ACTIVE || company.isActive
  )

  return {
    companyList: filteredCompany,
    currentCompanyId: userSessionSelectors.getCurrentCompanyId(state),
    currentCompanyName:
      userSessionSelectors.getCurrentCompanyNew(state)?.companyName,
    loading: getWaiter(state, GET_ALL_COMPANIES).isPending,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onChange: (companyId: string) => {
      if (companyId) {
        dispatch(userSessionActions.setCurrentCompany(companyId))
      }
    },
  }
}

export const HeaderCompanySelectorContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderCompanySelector)
